Ext.define('SA.AcsTable.TableSearchRegex', {
    singleton: true,

    fromString(string) {
        var regexString = string
            .split(/[^\w%#$]/)
            .filter(part => part !== '')
            .map(part => part.replace(/\$/g, '\\$'))
            .map(part => `(?=.*${part})`)
            .join('');

        return RegExp(regexString, 'i');
    }
});